export default "__VITE_ASSET__38fs71SI__"